import { render, staticRenderFns } from "./ProfessionalDetailEdit.vue?vue&type=template&id=1313ad1e&scoped=true"
import script from "./ProfessionalDetailEdit.vue?vue&type=script&lang=js"
export * from "./ProfessionalDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalDetailEdit.vue?vue&type=style&index=0&id=1313ad1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313ad1e",
  null
  
)

export default component.exports